import { GameTimes } from "./gameTimes";
import { parseSuccessfulResponse, RequestSender } from "./helpers";

async function getStudentGameTimes(request: RequestSender, id: string) {
  const response = await request("get", `/student/game-times/${id}`);
  return parseSuccessfulResponse(response, (data) => data as GameTimes);
}

export default getStudentGameTimes;
